import React from 'react';
import {FormGroup, Input, Label} from 'reactstrap';

const ExportDropDown = ({ exports, onChange }) => (
  <FormGroup>
    <Label for="exportSelect">export type</Label>
    <Input type="select" name="select" id="exportSelect" onChange={onChange}>
      <option key={1} value="null">please select export type</option>
      {exports.map(e => {
        const key = e.name + '_' + e.type + '_' + e.scope;
        return <option key={e.export_id} value={key}>{key.replace(/_/g, ', ')}</option>
      })}
    </Input>
  </FormGroup>
);

export default ExportDropDown;


// WEBPACK FOOTER //
// ./src/views/Patient/Export/ExportDropdown.js